import $ from 'jquery';
import layout from '../Layout';
import ProductForm from './ProductForm';
import ProductGallery from './ProductGallery';
import RTE from '../globals/RTE';
import SurfacePickUp from './SurfacePickUp';

export default class ProductDetails {
  constructor({ $el, section, inQuickshop = false }) {
    this.el = $el[0];
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.postMessage = section.postMessage;
    this.inQuickshop = inQuickshop;
    this.type = section.type;

    this.$el = $el;
    this.$window = $(window);
    this.$productImageItems = $('[data-product-image]', $el);
    this.$productDetails = $('[data-product-details]', $el);
    this.$productInfo = $('[data-product-info', $el);
    this.$menu = $('[data-product-menu-container]', $el);
    this.$atc = $('[data-product-atc]', $el);

    this.positionDetails = this._positionDetails.bind(this);
    this._handleVariantChange = this._handleVariantChange.bind(this);

    // Alert
    this.$alert = $('.product-alert', $el);

    this.productGallery = new ProductGallery(
      this.el.querySelector('[data-product-gallery]'),
      {
        enable_video_autoplay: section.data.gallery_video_autoplay,
        enable_video_looping: section.data.gallery_video_looping,
      },
    );

    this.rte = new RTE(this.$productDetails[0].querySelector('.rte'));

    this.listeningForVariantChange = false;
    this.listenForVariantChange();

    this.SurfacePickUp = new SurfacePickUp({
      el: this.el,
      product: this.data.product,
      initialVariantId: parseInt(this.data.initial_variant_id, 10),
      hasOnlyDefaultVariant: this.data.has_only_default_variant,
    });

    // Form
    if (!this.onboarding && this.data.form_is_inline) {
      this.form = new ProductForm(this.$el.find('[data-product-details]'), {
        form: $('[data-product-form-inline]', this.$el),
        productEl: this.$el[0],
        product: this.data.product,
        moneyFormat: window.Theme.moneyFormat,
        postMessage: section.postMessage,
        useHistory: this.data.use_history,
        enableCartRedirection: this.data.enable_cart_redirection,
        onAddToCart: () => this._onATC(),
        onSuccess: (response, quantity) => this._onAtcSuccess(response, quantity),
        onError: (response, error) => this._onAtcError(response, error),
      });

      if (this.type !== 'dynamic-product' && !this.inQuickshop) {
        $(window).trigger('product-variant-switch', { variant: this.form.variantHelper.getSelectedVariant() });
      }
    }

    // Handle layout changes
    this.onLayoutChange = () => this._layout();
    layout.onBreakpointChange(this.onLayoutChange);

    // Initial positioning
    this._layout();

    // Events
    this.events = [
      // Dismiss alert
      this.$alert
      .find('.product-alert-dismiss')
      .on('click.product', () => this._hideAlert()),
    ];
  }

  get gallery() {
    return this.productGallery;
  }

  listenForVariantChange() {
    if (!this.listeningForVariantChange) {
      $(window).on('product-variant-switch', this._handleVariantChange);
      this.listeningForVariantChange = true;
    }
  }

  stopListeningForVariantChange() {
    if (this.listeningForVariantChange) {
      $(window).off('product-variant-switch', this._handleVariantChange);
      this.listeningForVariantChange = false;
    }
  }

  unload() {
    this.$window.off('.product-details');
    layout.offBreakpointChange(this.onLayoutChange);
    this._hideAlert();

    this.rte.unload();

    if (this.form) this.form.unload();
    this.stopListeningForVariantChange();

    this.SurfacePickUp.unload();
  }

  _layout() {
    if (layout.isBreakpoint('L')) {
      this.$window.on('resize.product-details', this.positionDetails);
    } else {
      this.$window.off('resize.product-details');
    }

    this._positionDetails();
  }

  _positionDetails() {
    let isSticky = false;

    if (layout.isBreakpoint('L')) {
      const imagesHeight = $('[data-product-gallery]').outerHeight();
      const detailsHeight = this.$productDetails.outerHeight();
      const windowHeight = window.innerHeight;
      const menuHeight = this.$menu.outerHeight() || 0;
      const availableHeight = windowHeight - menuHeight;

      isSticky = (
        imagesHeight > availableHeight
        && detailsHeight < availableHeight
      );
    }

    this.$productDetails.toggleClass('product-details-sticky', isSticky);
  }

  _onATC() {
    this._hideAlert();
    this.$atc[0].classList.add('loading');
  }

  _onAtcSuccess() {
    this.$atc[0].classList.remove('loading');
    this.postMessage('header-minicart:set-open');
  }

  _onAtcError(response, error) {
    this.$atc[0].classList.remove('loading');
    this._showAlert(error, 'error');
  }

  _handleVariantChange(event, data) {
    this._onVariantChange(data);
  }

  _onVariantChange({ variant, firstLoad, isProduct }) {
    if (isProduct && !isProduct(this.data.product)) {
      return;
    }

    if (firstLoad) {
      if (this.type !== 'dynamic-product') {
        this._positionDetails();
      }
    }

    const $unitPrice = this.$productInfo.find('[data-unit-price]');
    const $unitPriceAmount = $unitPrice.find('[data-unit-price-amount]');
    const $unitPriceMeasure = $unitPrice.find('[data-unit-price-measure]');
    const $unitPriceQuantity = $unitPrice.find('[data-unit-price-quantity]');
    const $compareAtPrice = this.$productInfo.find('[data-variant-compare-at-price]');
    const $price = this.$productInfo.find('[data-variant-price]');
    const $taxLine = this.$productInfo.find('[data-tax-line]');

    this.productGallery.selectMediaByVariant(variant);

    this.$el.find('.product-form-inline-atc-button')
      .prop('disabled', !variant.available)
      .find('[data-product-inline-atc-text]')
      .text(variant.available
        ? this.data.text.product_available
        : this.data.text.product_unavailable,
      );

    $price.text(Shopify.formatMoney(variant.price, window.Theme.moneyFormat));

    if (variant.compare_at_price && variant.compare_at_price !== variant.price ) {
      $compareAtPrice.removeClass('money-compare-at-hidden');
      $compareAtPrice.text(Shopify.formatMoney(variant.compare_at_price, window.Theme.moneyFormat));
    } else {
      $compareAtPrice.addClass('money-compare-at-hidden');
    }

    if ($taxLine.length) {
      if (variant.taxable) {
        $taxLine.removeClass('hidden');
      } else {
        $taxLine.addClass('hidden');
      }
    }

    if (variant.unit_price) {
      $unitPrice.removeClass('hidden');

      if ($unitPriceQuantity.length) {
        $unitPriceQuantity.text(`${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`);
      }

      if ($unitPriceAmount.length) {
        $unitPriceAmount.text(Shopify.formatMoney(variant.unit_price, window.Theme.moneyFormat));
      }

      if ($unitPriceMeasure.length) {
        if (variant.unit_price_measurement.reference_value !== 1) {
          $unitPriceMeasure.text(`${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`);
        } else {
          $unitPriceMeasure.text(variant.unit_price_measurement.reference_unit);
        }
      }
    } else {
      $unitPrice.addClass('hidden');
    }
  }

  _showAlert(message, type = null) {
    this._hideAlert();

    // Add class name
    if (type) {
      this.alertClassName = `product-alert-${type}`;
      this.$alert.addClass(this.alertClassName);
    }

    // Set text
    const $message = this.$alert.find('.product-alert-message');
    $message.html(message);
    this.$alert.one('revealer-hide', event => $message.text(''));

    // Show
    this.$alert.revealer('show');

    // Positioning
    this._positionAlert();
    $(window).on('scroll.product-alert', event => this._positionAlert());
    this.alertTimeout = setTimeout(() => {
      this._hideAlert();
    }, 3000);
  }

  _hideAlert() {
    clearTimeout(this.alertTimeout);
    // Remove custom class names
    this.$alert.removeClass(this.alertClassName);
    this.alertClassName = null;

    // Stop positioning
    $(window).off('scroll.product-alert');

    // Hide
    this.$alert.revealer('hide');
  }

  _positionAlert() {
    if (this.inQuickshop) {
      return;
    }

    this.$alert[0].style.top = window.pageYOffset;
    this.$alert[0].classList.add('product-alert-fixed');
  }
}
